/* eslint-disable react-hooks/exhaustive-deps */
import PropTypes from 'prop-types';
import OverFlowTooltipWithTabsMui from '@/component/common/OverFlowTooltipWithTabsMui';
import WaitingGPTResponseMessage from './WaitingGPTResponseMessage';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useSetRecoilState } from 'recoil';
import { setPanelSelector } from '@/state/selector/panelSelector';
import Utils from '@/common/utils/utils';
import Constant from '@/common/constant/Constant';
import AIResponse from './AIResponse';
import RenderAttachImageOnChatPost from './RenderAttachImageOnChatPost';
import RenderAttachFileOnAiChatPost from './RenderAttachFileOnAiChatPost';
import GeneratedFileErrorMessage from './GeneratedFileErrorMessage';
import ViewFile from './ViewFile';
import MessageIsFromMe from './MessageIsFromMe';
import AiLogDetail from './InputChatAiGroupButtons/components/AiLogDetail';
import trI18n from '@/common/utils/trI18n';
import { tr } from '@/common/utils/tr';
import { useTranslationSubscription } from '@/hooks/useTranslation';

ListMessageChatAI.propTypes = {
    listMessageContent: PropTypes.any,
    chatThreadId: PropTypes.any,
    setListMessageContent: PropTypes.any,
    isEnableBtnSend: PropTypes.any,
    setIsEnableBtnSend: PropTypes.any,
    panelId: PropTypes.any,
    corporationDetail: PropTypes.any,
    currentUserDetail: PropTypes.any,
    setUserSelectedPrompt: PropTypes.any,
    idOfResponseMessage: PropTypes.any,
    setIdOfResponseMessage: PropTypes.any,
    projectInfo: PropTypes.any,
    projectInuseDetail: PropTypes.any,
    usingAI: PropTypes.any,
    isAiAutoLog: PropTypes.any,
    aiAutoPromptTitle: PropTypes.any,
    isShowButtonStop: PropTypes.any,
    setIsShowButtonStop: PropTypes.any,
    isOnlyRunChatAI: PropTypes.any,
    setIsOnlyRunChatAI: PropTypes.any,

    setStreamedContent: PropTypes.any,
    streamedContent: PropTypes.any,

    isStopStreamContent: PropTypes.any,
    setIsStopStreamContent: PropTypes.any
};

export default function ListMessageChatAI({
    chatThreadId,
    listMessageContent,
    setListMessageContent,
    isEnableBtnSend,
    setIsEnableBtnSend,
    panelId,
    corporationDetail,
    currentUserDetail,
    setUserSelectedPrompt,
    idOfResponseMessage,
    setIdOfResponseMessage,
    projectInfo,
    projectInuseDetail,
    usingAI,
    isAiAutoLog = false,
    isAiAssistantLog = false,
    aiAutoPromptTitle,

    isShowButtonStop,
    setIsShowButtonStop,
    isOnlyRunChatAI,
    setIsOnlyRunChatAI,

    setStreamedContent,
    streamedContent,

    isStopStreamContent,
    setIsStopStreamContent,
    usingChatGptModel,
    usingReasoningEffort,
    setReasoningDataStream,
    reasoningDataStream
}) {
    // Re-render when the translation dictionary loads/extends so tr() text updates.
    useTranslationSubscription();

    const addNewPanel = useSetRecoilState(setPanelSelector);
    const messagesEndRef = useRef(null);
    const [isDisplayJump, setIsDisplayJump] = useState(false);
    const [messageWaiting, setMessageWaiting] = useState(null);

    // Deduplicate messages by id (O(n) with Set)
    const uniqueMessages = useMemo(() => {
        const seen = new Set();
        return listMessageContent?.filter(message => {
            if (message.isLoadingMessage) return false;
            if (!message.id) return true;
            if (seen.has(message.id)) return false;
            seen.add(message.id);
            return true;
        }) || [];
    }, [listMessageContent]);

    useEffect(() => {
       if (listMessageContent.length > 0 || !!messageWaiting) {
            jumpToBottom();
       }
    }, [listMessageContent, messageWaiting]);

    // Theo dõi message đang loading và cập nhật messageWaiting
    useEffect(() => {
        const loadingMessage = listMessageContent?.find(message => message.isLoadingMessage);
        if (loadingMessage) {
            const loadingMessageId = loadingMessage.idOfLoadingMessage;
            const currentWaitingId = messageWaiting?.idOfLoadingMessage;
            if (loadingMessageId !== currentWaitingId) {
                setMessageWaiting(loadingMessage);
            }
        } else {
            setMessageWaiting({});
        }
    }, [listMessageContent]);

    const scrollToBottom = () => {
        setTimeout(() => {
            jumpToBottom();
        }, 1000);
    };

    const jumpToBottom = () => {
        let idDivContentList = `divChatContentList-${panelId}-${chatThreadId}`;
        const element = document.getElementById(idDivContentList);
        if (!element) {
            return;
        }

        // Delay 1 frame to ensure the layout is fully rendered
        setTimeout(() => {
            requestAnimationFrame(() => {
                element.scrollTop = element.scrollHeight;
                setIsDisplayJump(false);
            });
        }, 0);
    };

    const handleScrollListMessage = (e, chatThreadId) => {
        let element = e.target;
        if (element.offsetHeight + element.scrollTop >= element.scrollHeight - 100) {
            setIsDisplayJump(false);
        } else {
            setIsDisplayJump(true);
        }
    };

    const checkShowAiWaiting = () => {
        if (isStopStreamContent === Constant.STREAM_STATUS.STOP && (Utils.isEmptyString(streamedContent) && Utils.isEmptyArray(reasoningDataStream)) && isOnlyRunChatAI) {
            return false;
        }
        return true
    }
    
    return (
        <>
            <div
                className="ai-list-msg-content"
                id={`divChatContentList-${panelId}-${chatThreadId}`}
                onScroll={e => handleScrollListMessage(e, chatThreadId)}
            >
                {isAiAutoLog && aiAutoPromptTitle.length > 0 && (
                    <p className='ai-auto-prompt-title'>{tr(`「${aiAutoPromptTitle}」から起動されました。`)}</p>
                )}

                {uniqueMessages.map((message, index) => {
                    const filterContent = Utils.replaceUrls(
                        message.isFromMe ? Utils.escapeHtmlCharacters(message.content) : message.content,
                        false,
                        false,
                        '',
                        message?.isFromMe,
                        true
                    );

                    if(message.type === Constant.CONSTANT_SYSTEM_CHAT_AI_MESSAGE_TYPE.ERROR_NOT_CONNECTED_CONNECTOR) {
                        let listNotConnectedConnector = message.listNotConnectedConnector;
                    listNotConnectedConnector = Array.isArray(listNotConnectedConnector) ? listNotConnectedConnector : [];

                    // listNotConnectedConnector is an array of string service names

                    return (
                        <div
                            key={message.id || index}
                            className="ai-chat-item-message ai-from-them display"
                        >
                            <div className="ai-message-error-header" />
                            <div className="ai-chat-msg-wrap">
                                <div className="ai-message-error">
                                    {trI18n('ERROR_MESSAGE_NOT_CONNECTED_CONNECTOR')}:{' '}
                                    {listNotConnectedConnector && listNotConnectedConnector.length > 0
                                        ? listNotConnectedConnector.map((service, idx) => {
                                              const hasPerService =
                                                  typeof service === 'string' && service.includes('[PER]');
                                              return (
                                                  <React.Fragment key={service + idx}>
                                                      <span>{service}</span>
                                                      {hasPerService && (
                                                          <span
                                                              className="ai-message-error-settings-link"
                                                              style={{
                                                                  color: '#3973DF',
                                                                  cursor: 'pointer',
                                                                  marginLeft: 6,
                                                                  marginRight: 6,
                                                                  fontWeight: 500,
                                                                  textDecoration: 'underline',
                                                                  fontSize: 12,
                                                              }}
                                                              onClick={() => {
                                                                  addNewPanel({
                                                                      type: Constant.PANEL_TYPE.PERSONAL_MANAGEMENT,
                                                                      tabId: Constant.PANEL_TYPE.SYSTEM_USER_PROFILE,
                                                                      initialTab: 'externalIntegration',
                                                                      props: {}
                                                                  });
                                                              }}
                                                          >
                                                              {tr('設定画面へ')}
                                                          </span>
                                                      )}
                                                      {idx !== listNotConnectedConnector.length - 1 && ', '}
                                                  </React.Fragment>
                                              );
                                          })
                                        : null}
                                </div>
                            </div>
                        </div>
                    );

                    }

                    // Check if message is error (either from flag or by detecting error pattern in content)
                    const isUnsupportedModelError = Constant.AI_ERROR_PATTERNS.UNSUPPORTED_MODEL.test(message?.content);
                    const isErrorMessage = message.isError || isUnsupportedModelError;

                    let messageClass = 'ai-message-text';
                    if (isErrorMessage) {
                        messageClass = 'ai-message-error';
                    } else if (message.isWaring) {
                        messageClass = 'ai-message-warning';
                    }

                    let messageDirectionClass = '';
                    let aiAnswerClass = '';
                    let hiddenClass = message.isHidden ? 'hidden' : 'display';

                    if (message.isFromMe) {
                        messageDirectionClass = 'ai-from-me';
                    } else {
                        messageDirectionClass = 'ai-from-them';
                        aiAnswerClass = !message.isError && Utils.isEmptyString(message.content) && Utils.isEmptyArray(message.reasoningData) ? 'hidden' : '';
                        if (
                            ([Constant.POST_TYPE.IMAGE, Constant.POST_TYPE.MSG_FILES].includes(message.postType) || message.isGeneratedFileError) &&
                            Utils.isEmptyString(message.content) &&
                            !message.isError
                        ) {
                            aiAnswerClass = '';
                        }
                    }

                    const displayName = (message.isFromMe || message.isOperatorPromptLog || message.isAiAssistantLog)
                        ? message.user
                        : tr('AI');
                    

                    return (
                        <div
                            key={message.id || index}
                            className={`ai-chat-item-message ${messageDirectionClass} ${hiddenClass} ${aiAnswerClass}`}
                        >
                            {!isErrorMessage ? (
                                <div className="ai-message-header">
                                    {!message.isFromMe && (
                                        <div className="ai-avatar">
                                            <img src="/assets/image/avatar-ai.svg" alt="avatar" />
                                        </div>
                                    )}
                                    <OverFlowTooltipWithTabsMui
                                        value={displayName}
                                        className="ai-chat-name"
                                    />
                                    <div className="ai-chat-time">
                                        {message?.dateTime ? message?.dateTime : ''}
                                    </div>
                                </div>
                            ) : (
                                <div className="ai-message-error-header"></div>
                            )}
                            {message.isFromMe ? (
                                <MessageIsFromMe 
                                    message={message}
                                    filterContent={filterContent}
                                    isAiAutoLog={isAiAutoLog}
                                />
                            ) : (
                                <div className="ai-chat-msg-wrap">
                                    {message.postType === Constant.POST_TYPE.IMAGE && (
                                        <RenderAttachImageOnChatPost messageData={message} />
                                    )}
                                    {(!Utils.isEmptyString(message.content) || !Utils.isEmptyArray(message.reasoningData)) && (
                                        message.postType === Constant.POST_TYPE.FILE ? (
                                            <ViewFile messageData={message} />
                                        ) : (
                                            <div className={messageClass}>
                                                <AIResponse data={message} isPublicSite={false} />
                                            </div>
                                        )
                                    )}
                                    {message.postType === Constant.POST_TYPE.MSG_FILES && (
                                        <RenderAttachFileOnAiChatPost messageData={message} />
                                    )}
                                    {message.isGeneratedFileError && <GeneratedFileErrorMessage />}
                                </div>
                            )}
                        </div>
                    );
                })}

                {/* Render message is loading form messageWaiting */}
                { checkShowAiWaiting() && messageWaiting && Object.keys(messageWaiting).length > 0 && (
                    <div
                        className={`ai-chat-item-message ${
                            messageWaiting.isFromMe ? 'ai-from-me' : 'ai-from-them'
                        } ${messageWaiting.isHidden ? 'hidden' : 'display'}`}
                    >
                        {!messageWaiting.isError ? (
                            <div className="ai-message-header">
                                {!messageWaiting.isFromMe && (
                                    <div className="ai-avatar">
                                        <img src="/assets/image/avatar-ai.svg" alt="avatar" />
                                    </div>
                                )}
                                <OverFlowTooltipWithTabsMui
                                    value={messageWaiting.isFromMe ? messageWaiting.user : tr('AI')}
                                    className="ai-chat-name"
                                />
                                <div className="ai-time-chat">
                                    {messageWaiting?.dateTime ? messageWaiting?.dateTime : ''}
                                </div>
                            </div>
                        ) : (
                            <div className="ai-message-error-header"></div>
                        )}
                        <div className="ai-chat-msg-wrap">
                        {messageWaiting.isFromMe ? (
                            <div
                                className="ai-message-text"
                                style={{ backgroundColor: isAiAutoLog ? '#FFEDB3' : '' }}
                                dangerouslySetInnerHTML={{ __html: Utils.replaceUrls(
                                    Utils.escapeHtmlCharacters(messageWaiting.content),
                                    false,
                                    false,
                                    '',
                                    messageWaiting?.isFromMe,
                                    true
                                ) }}
                            />
                        ) : (
                            <div className="ai-message-text">
                                <WaitingGPTResponseMessage
                                    setListMessageContent={setListMessageContent}
                                    setIsEnableBtnSend={setIsEnableBtnSend}
                                    idOfResponseMessage={idOfResponseMessage}
                                    scrollToBottom={scrollToBottom}
                                    usingAI={usingAI}
                                    usingChatGptModel={usingChatGptModel}
                                    usingReasoningEffort={usingReasoningEffort}

                                    isShowButtonStop={isShowButtonStop}
                                    setIsShowButtonStop={setIsShowButtonStop}
                                    isOnlyRunChatAI={isOnlyRunChatAI}
                                    setIsOnlyRunChatAI={setIsOnlyRunChatAI}

                                    setStreamedContent={setStreamedContent}
                                    streamedContent={streamedContent}

                                    isStopStreamContent={isStopStreamContent}
                                    setIsStopStreamContent={setIsStopStreamContent}
                                    setReasoningDataStream={setReasoningDataStream}
                                />
                            </div>
                        )}
                        </div>
                    </div>
                )}

                {listMessageContent.length > 0 && (<div ref={messagesEndRef} ></div>)}
            </div>

            {/* Jump to Bottom */}
            <button
                className={`btn-reset-default ${isDisplayJump ? 'ai-jumpBottom' : 'ai-jumpBottom ai-jumpBottom--done'}`}
                onClick={jumpToBottom}
            >
                <div className="ai-jumpBottom-wrap">
                    <div className="ai-jumpBottom-box">
                        <svg width="16px" height="16px" viewBox="0 0 24 24" className="">
                            <path fill="none" d="M0 0h24v24H0V0z"></path>
                            <path d="M20 12l-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8 8-8z"></path>
                        </svg>
                        {tr('Jump to Bottom')}
                    </div>
                </div>
            </button>

            {/* ai-log-url-btn */}
            {isAiAutoLog && (
                <AiLogDetail
                    chatThreadId={chatThreadId}
                    listMessageContent={listMessageContent}
                    currentUserDetail={currentUserDetail}
                    corporationDetail={corporationDetail}
                    projectInuseDetail={projectInuseDetail}
                    isAiAssistantLog={isAiAssistantLog}
                />
            )}
        </>
    );
}
